const mobileBreakpoint = 992;

/**
 * check if app is mobile
 */
export function isMobile(): boolean {
    return window.innerWidth <= mobileBreakpoint;
}
